import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography, List, ListItem, ListItemText } from '@mui/material';

const DeadlineList = styled(List)(({ theme }) => ({
  '.MuiListItem-root': {
    borderRadius: '8px',
    marginBottom: '8px',
    padding: '16px',
    backgroundColor: '#1e293b',
    color: '#ffffff !important',
    '&:hover': {
      backgroundColor: '#2d3748',
    },
    '& .MuiTypography-root': {
      color: '#ffffff !important',
      fontWeight: 'inherit !important',
    },
    transition: 'background-color 0.2s ease'
  }
}));

const DeadlineDate = styled(Typography)({
  color: '#3b82f6 !important',
  fontSize: '0.875rem',
  marginBottom: '4px'
});

const DeadlineTitle = styled(Typography)({
  color: '#ffffff !important',
  fontSize: '1rem'
});

interface Deadline {
  id: string;
  date: Date;
  title: string;
  description: string;
  type?: string;
  priority?: 'low' | 'medium' | 'high';
}

interface UpcomingDeadlinesProps {
  deadlines: Deadline[];
  onDeadlineClick?: (deadline: Deadline) => void;
}

export const UpcomingDeadlines: React.FC<UpcomingDeadlinesProps> = ({
  deadlines,
  onDeadlineClick
}) => {
  return (
    <DeadlineList>
      {deadlines.map((deadline, index) => (
        <ListItem 
          key={deadline.id || index}
          onClick={() => onDeadlineClick?.(deadline)}
          sx={{ cursor: onDeadlineClick ? 'pointer' : 'default' }}
        >
          <Box>
            <DeadlineDate>
              {deadline.date.toLocaleDateString()}
            </DeadlineDate>
            <DeadlineTitle>
              {deadline.title || 'Untitled Deadline'}
            </DeadlineTitle>
            <Typography 
              variant="body2" 
              sx={{ 
                color: (theme) => theme.palette.mode === 'dark' ? '#94a3b8' : '#64748b',
                mt: 1 
              }}
            >
              {deadline.description}
            </Typography>
          </Box>
        </ListItem>
      ))}
    </DeadlineList>
  );
}; 